// extracted by mini-css-extract-plugin
module.exports = {"main":"main-template_main__3zmaz","header":"main-template_header__36zRT","footer":"main-template_footer__1VPIf"};